export type AuthColorMode = 'light' | 'dark';

export const AUTH_THEME_TOKENS = {
  light: {
    documentBg: '#eef3f8',
    pageBg:
      'radial-gradient(circle at 18% 0%, rgba(59,130,246,0.10), transparent 32%), linear-gradient(135deg, #f8fafc 0%, #eef4fb 48%, #e6edf7 100%)',
    panelBg:
      'linear-gradient(160deg, rgba(255,255,255,0.72), rgba(226,232,240,0.58))',
    panelBorder: 'rgba(148,163,184,0.22)',
  },
  dark: {
    documentBg: '#07111f',
    pageBg:
      'radial-gradient(circle at 18% 14%, rgba(56,189,248,0.12), transparent 28%), radial-gradient(circle at 88% 12%, rgba(79,70,229,0.12), transparent 30%), linear-gradient(135deg, #07111f 0%, #091421 52%, #0b1220 100%)',
    panelBg:
      'linear-gradient(155deg, rgba(15,23,42,0.58), rgba(30,41,59,0.34))',
    panelBorder: 'rgba(148,163,184,0.14)',
  },
} as const;

export function resolveAuthTheme(colorMode: AuthColorMode) {
  return AUTH_THEME_TOKENS[colorMode];
}
